<div class="page-head-section">
  <p>Member units</p>
</div>

<div class="unit">

  <div class="new-unit">
    <div class="filters" style="margin: 20px;">


      <div class="drop-area res-area">
        <button (click)="UpdateFilter('State')" class="clear-filter" [className]="typeFilter!=='National' ? 'clear-filter active-class' : 'clear-filter'">State  Association</button>
        <button (click)="UpdateFilter('National')" class="clear-filter" [className]="typeFilter=='National' ? 'clear-filter active-class' : 'clear-filter'">Associate  Members</button>

      </div>


    </div>
    <div class="ui-g head-row">

      <div class="ui-g-2">Name</div>
      <div class="ui-g-2">State</div>
      <div class="ui-g-2">President Name</div>
      <div class="ui-g-2">Secretary Name</div>
      <div class="ui-g-2">Mobile</div>
      <div class="ui-g-2">Address </div>

    </div>

    <div class="ui-g content-row" *ngFor="let data of memberAssociation">
      <div class="ui-g-2">
        {{ data?.memberAssociation?.name }}
      </div>

      <div class="ui-g-2">
        {{ data?.memberAssociation?.state }}
      </div>

      <div class="ui-g-2">
        {{ data?.presidentName }}
      </div>

      <div class="ui-g-2">
        {{ data?.secretaryName }}
      </div>
      <div class="ui-g-2">
        <span style="font-family: Bold">President Mobile :</span> {{ data?.presidentMobile }}
        <br />
        <span style="font-family: Bold">President Email :</span> {{ data?.presidentEmail }}
        <br />
        
        <span style="font-family: Bold">Secretary Mobile :</span> {{ data?.secretaryMobile }}
        <span style="font-family: Bold">Secretary Email :</span> {{ data?.secretaryEmail}}
        <br />

      </div>
      <div class="ui-g-2">
        <span style="font-family: Bold"> President Address : </span> {{ data?.presidentAddress }}
        <br />
        <span style="font-family: Bold">Secretary Address : </span> {{ data?.secretaryAddress }}

      </div>
    </div>
  </div>
</div>